import { render, staticRenderFns } from "./rule-form.vue?vue&type=template&id=7fdd7f75&"
import script from "./rule-form.vue?vue&type=script&lang=ts&"
export * from "./rule-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports